import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import ErrorPage from "./components/ErrorPage";
import AppContextProvider from "./components/hooks/context";
import { ChakraProvider } from '@chakra-ui/react'
// 导入i18n配置，自动初始化
import "./i18n";
const container = document.getElementById("root");
const root = createRoot(container!);

const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
    errorElement: <ErrorPage />,
  },
]);
root.render(
  <ChakraProvider>
    <AppContextProvider>
      <RouterProvider router={router} />
    </AppContextProvider>
  </ChakraProvider>
);
